import React, { useContext, useEffect, useState } from "react";
import { Upload, Image, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import GlobalContext from "../context/GlobalContext";

const CustomUpload = ({
  field,
  multiple = false,
  accept = "*",
  customRequest,
  setSelectedDiplomaFiles,
  id,
  type,
  value, 
  showIcon
}) => {
  const [fileList, setFileList] = useState([]);

  const { form } = useContext(GlobalContext);

  const handleChange = ({ fileList: newFileList }) => {

    setFileList(multiple ? newFileList : newFileList.slice(-1));
  };

  const uploadButton = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // height: 100,
        // height:"3rem",
        width: "100%",
        border: "1px dashed #d9d9d9",
        borderRadius: 8,
        backgroundColor: "#fafafa",
        transition: "all 0.3s",
        cursor: "pointer",
        padding: "0.5rem",
      }}
    >
      <PlusOutlined style={{ fontSize: 24, color: "#1890ff" }} />
      <div
        style={{
          marginTop: 8,
          fontSize: 14,
          color: "#555",
          textAlign: "center",
        }}
      >
        {field?.buttonName || "Ajouter un fichier"}
      </div>
    </div>
  );

  const extractFileName = (url) => {
    if (url) {
      return url?.split("/").pop().split("?")[0];
    }
  };

  const getRcenetFiles = () => {
    console.log(value);
    
    const initialValues = form.getFieldsValue();
    const fileUrl = value || initialValues[field.name] ;

    if (fileUrl) {
      setFileList([
        {
          uid: "-1",
          name: extractFileName(fileUrl),
          status: "done",
          url: fileUrl,
        },
      ]);
    }
  };
  useEffect(() => {
    getRcenetFiles();
  }, []);

  return (
    <Upload
      customRequest={(options) => {
        customRequest(id,options);
      }}
      listType="picture"
      fileList={fileList}
      onChange={handleChange}
      multiple={multiple}
      accept={accept}
      style={{ width: "100%", cursor: "pointer" }}
      showUploadList={{
      showRemoveIcon: showIcon 
  }}
      onRemove={() => {
        form.setFieldsValue({
          ...form.getFieldsValue(),
          [field.name]:null
        })
        if (type === "diplome") {
          setSelectedDiplomaFiles((prev) => {
            const copy = { ...prev };
            delete copy[id];
            return copy;
          });
        }
      }}
    >
      {(!multiple && fileList.length >= 1) || (multiple && fileList.length >= 8)
        ? null
        : uploadButton}
    </Upload>
  );
};

export default CustomUpload;
